import { httpClient } from '@/shared/lib/http-client';
import { API_ENDPOINTS } from '@/shared/config/api';

export interface CustomerInformation {
  id: number;
  contentHtml: string;
  createdAt: string;
  updatedAt: string;
}

export interface CustomerInformationResponse {
  success: boolean;
  content: CustomerInformation;
  message?: string;
}

export interface UpdateCustomerInformationData {
  contentHtml: string;
}

interface UploadImageResponse {
  success: boolean;
  url: string;
}

interface UploadDocumentResponse {
  success: boolean;
  url: string;
  originalName: string;
}

type ProgressCallback = (event: { loaded: number; total?: number }) => void;

export const customerInformationApi = {
  async get(): Promise<CustomerInformationResponse> {
    const response = await httpClient.get<CustomerInformationResponse>(
      API_ENDPOINTS.CUSTOMER_INFORMATION.GET
    );
    return response.data;
  },

  async update(
    data: UpdateCustomerInformationData
  ): Promise<CustomerInformationResponse> {
    const response = await httpClient.patch<CustomerInformationResponse>(
      API_ENDPOINTS.CUSTOMER_INFORMATION.UPDATE,
      data
    );
    return response.data;
  },

  async uploadImage(
    file: File,
    onProgress?: ProgressCallback
  ): Promise<{ url: string }> {
    const response = await httpClient.uploadFile<UploadImageResponse>(
      API_ENDPOINTS.CUSTOMER_INFORMATION.UPLOAD_IMAGE,
      file,
      'image',
      onProgress
    );
    return { url: response.data.url };
  },

  async uploadDocument(
    file: File,
    onProgress?: ProgressCallback
  ): Promise<{ url: string; originalName: string }> {
    const response = await httpClient.uploadFile<UploadDocumentResponse>(
      API_ENDPOINTS.CUSTOMER_INFORMATION.UPLOAD_DOCUMENT,
      file,
      'file',
      onProgress
    );
    return { url: response.data.url, originalName: response.data.originalName };
  }
};
